import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {BLUE_LIGHT, BLUE_LIGHTER, GRAY, GRAY_DARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface Props {
  className?: string;
  disabled?: boolean;
  highlighted?: boolean;
  onClick?: () => void;
  dataTestAttrs?: DataTestAttrs;
}

export default function SettingsIcon(props: Props): JSX.Element {
  const className = classNames(
    css(styles.icon),
    css(props.disabled ? styles.disabled : styles.enabled),
    css(props.highlighted && styles.highlighted),
    'settingsIcon',
    props.className
  );
  // eslint-disable-next-line no-restricted-syntax
  const newProps = _.omit(props, 'className', 'highlighted', 'onClick');

  const icon = <BenchlingIcon className={className} icon="settings" {...newProps} />;

  if (props.onClick) {
    return (
      <span
        role="button"
        aria-label="settings"
        tabIndex={0}
        aria-disabled={props.disabled}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (!props.disabled && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            props.onClick?.();
          }
        }}
        onClick={props.disabled ? undefined : props.onClick}
      >
        {icon}
      </span>
    );
  } else {
    return icon;
  }
}

const styles = StyleSheet.create({
  icon: {
    fontSize: '14px',
  },
  enabled: {
    color: GRAY_DARK,
    ':hover': {
      color: BLUE_LIGHT,
    },
    cursor: 'pointer',
  },
  disabled: {
    color: GRAY,
  },
  highlighted: {
    color: BLUE_LIGHT,
    ':hover': {
      color: BLUE_LIGHTER,
    },
  },
});
